// migrated 1:1 from @nexato/nx-core-module (#682)
import { gql } from 'apollo-angular';
import { IssueStatusGroup } from '../../../entities/issue/issue-status-group';


export const GET_STATUSGROUPS_QUERY = gql`
query getIssueStatusGroups{
  getIssueStatusGroups{
    code
    label
    description
    binaryStatusLabel
    binaryStatusCode
    isOpen
    isClosed
    issueStatuses {
      id
      code
      label
      roles
      color
      statusGroup{
        code
      }
    }
  }
}
`;

export interface GetIssueStatusGroupsResponse {
  getIssueStatusGroups: IssueStatusGroup[];
  loading: boolean;
}
